<template>
  <RemoteTable ref="table" :form="form" :table="table">
  </RemoteTable>
</template>

<script>
import RemoteTable from '@/components/RemoteTable'

export default {
  components: {
    RemoteTable
  },
  data() {
    return {
      form: {
        configs: [
          {label: "国家代码", name: "gjdm", type: "input", value: ""},
          {label: "类型", name: "type", type: "select", value: "", url: "/dict/list/sms/type"},
        ],
        tools: [
          {
            icon: "el-icon-plus", click: () => {
              this.$router.push("/config/price/0")
            }
          },
        ]
      },
      table: {
        urlPrefix: "/price",
        defaultSort: {prop: 'id', order: 'descending'},
        columns: [
          {label: "国家代码", name: "gjdm"},
          {label: "国家英文缩写", name: "gjywsx"},
          {label: "国家中文名称", name: "gjzwsx"},
          {label: "号段", name: "segment"},
          {label: "单价", name: "price", width: 80},
          {label: "类型", name: "type", width: 120},
          {label: "创建时间", name: "createTime", width: 150},
        ],
        tools: [],
        primaryColumns: [
          {
            name: "gjdm", method: (row) => {
              this.$router.push("/config/price/" + row['id']);
            }
          }
        ],
      }
    }
  }
}
</script>